import { escapeHtml, formatRelative } from './formatUtils';

export interface HistoryEntryRenderable {
	topicSlug: string | null;
	chapterId: string;
	chapterIndex: number | null;
	progressPercent: number;
	updatedAt: string;
	topicTitle: string | null;
	chapterTitle: string | null;
	coverImageUrl: string | null;
}

const BOOK_ICON = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"></path><path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5z"></path></svg>';

/** Renders the shared, single-action learning-history entry used by Profile and History. */
export function renderHistoryEntry(item: HistoryEntryRenderable): HTMLButtonElement {
	const template = document.createElement('template');
	const title = item.topicTitle ?? 'Untitled topic';
	const pct = Math.max(0, Math.min(100, Math.round(item.progressPercent ?? 0)));
	const chapterLabel = item.chapterIndex !== null && item.chapterTitle
		? `Ch.${item.chapterIndex} · ${item.chapterTitle}`
		: `Chapter ${item.chapterId}`;
	const topicSlug = item.topicSlug ?? '';
	template.innerHTML = `<button type="button" class="history-entry" data-proto-click="resumeHistoryChapter()" data-history-topic-slug="${escapeHtml(topicSlug)}" data-history-chapter-id="${escapeHtml(item.chapterId)}" data-history-chapter-index="${escapeHtml(String(item.chapterIndex ?? ''))}" data-history-progress-percent="${pct}" aria-label="Continue ${escapeHtml(title)}: ${escapeHtml(chapterLabel)} at ${pct}%">
		<span class="history-entry-icon" aria-hidden="true">${BOOK_ICON}</span>
		<span class="history-entry-body">
			<span class="history-entry-title">${escapeHtml(title)}</span>
			<span class="history-entry-meta">${escapeHtml(chapterLabel)} · ${formatRelative(item.updatedAt)}</span>
			<span class="history-entry-progress"><span class="history-entry-progress-bar" style="width:${pct}%;"></span></span>
		</span>
		<span class="history-entry-pct">${pct}%</span>
	</button>`;
	const entry = template.content.firstElementChild as HTMLButtonElement;
	paintHistoryCover(entry, item.coverImageUrl);
	return entry;
}

function paintHistoryCover(entry: HTMLElement, coverImageUrl: string | null): void {
	if (!coverImageUrl) return;
	const host = entry.querySelector<HTMLElement>('.history-entry-icon');
	if (!host) return;
	const image = document.createElement('img');
	image.src = coverImageUrl;
	image.alt = '';
	image.loading = 'lazy';
	host.replaceChildren(image);
	host.classList.add('history-entry-icon--cover');
}
